import { AutomaticDebitBank } from '../interfaces/protheus/AutomaticDebitBank';

export const convertAutomaticDebitBankProtheusToAutomaticDebitBank = (
  automaticDebitBank: any
): AutomaticDebitBank => ({
  code: automaticDebitBank.Z37_BANCO,
  bank: automaticDebitBank.Z37_DESC,
});
